import { useTranslatable } from 'src/hooks/locale/utils'
import AdministratorCoursePlaceholderPage from './AdministratorCoursePlaceholderPage'

export default function AdministratorCourseSurveyResultsPage(): JSX.Element {
  const t = useTranslatable()
  return <AdministratorCoursePlaceholderPage title={t('subPage:survey_results')} />
}
